<div data-testid="trials-ending" class="trials-ending">
  <div class="trials-ending__header">
    <div class="trials-ending__titles">
      <h4 data-testid="trials-ending-title" class="trials-ending__title">{{ title }}</h4>
      <p data-testid="trials-ending-description" class="trials-ending__description">{{ description }}</p>
    </div>
  </div>
  @if (failed) {
    <app-admin-dashboard-empty data-testid="trials-ending-failed" icon="fa-regular fa-circle-exclamation" [title]="failedTitle"
                               body="Try again, or pick another period." [compact]="true"></app-admin-dashboard-empty>
  } @else if (rows.length) {
    <ul data-testid="trials-ending-list" class="adb-list">
      @for (row of rows; track $index) {
        <li data-testid="trial-row" class="adb-list__row" [title]="row.companyId">
          <span class="adb-list__main">
            <span data-testid="trial-company" class="adb-list__name">{{ row.companyName }}</span>
            <span data-testid="trial-detail" class="adb-list__reason" [title]="detailText(row)">{{ detailText(row) }}</span>
          </span>
          <span class="adb-list__side">
            @if (row.likelihood) {
              <span data-testid="trial-rate" class="adb-list__figure">{{ row.likelihood.rate | percent:'1.0-0' }}</span>
              <span data-testid="trial-confidence" class="adb-conf adb-conf--{{ row.likelihood.confidence }}">{{ row.likelihood.confidence }}</span>
            }
            <span data-testid="trial-when" class="adb-list__when" [title]="'Ends ' + (row.trialEnd | date:'d MMM yyyy':'UTC')">{{ endsText(row.daysLeft) }}</span>
          </span>
        </li>
      }
    </ul>
  } @else if (loaded) {
    <app-admin-dashboard-empty data-testid="empty" icon="fa-regular fa-hourglass-end" title="No trials end this week"
                               body="Running trials and their predictions are in the Needs attention band."></app-admin-dashboard-empty>
  }
</div>
